import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboard} from '@fortawesome/free-regular-svg-icons';

const ClipboardIcon = props => {
    const {iconFillColor = 'white', round = false, borderRadius = 0, bgColor = 'darkgray', size = 16} = props;
    return (
        <div
            className="VerticalCenter"
            style={{
                width: size,
                height: size,
                borderRadius: round ? '50%' : borderRadius,
                backgroundColor: bgColor,
            }}>
            <FontAwesomeIcon icon={faClipboard} style={{ color: iconFillColor, fontSize: size * 0.5 }} />
        </div>
    );
};

export default ClipboardIcon;
